// import { getUserIp } from '../cartHelpers';
import { v4 as uuidv4 } from 'uuid';

import { Order } from '../types';
import { LineItem } from '../types/orderTypes';
import { trackJustUno } from '../vendor/justuno';
import { StoreApi as api } from './instances';

export const createOrder = (
  data:
    | {
        user_id: number;
      }
    | { token: string },
) => api.post<Order>('/v2/orders/', data);

export const getOrder = (orderId: number) =>
  api.get<Order>(`/v2/orders/${orderId}`);

export const addLineItem = async (data: {
  lineItem: {
    variant_id: number;
    quantity: number;
  };
  orderId: number;
}) => {
  // eventId is used to tie the request and GTM event information
  const eventId = uuidv4();

  // do we still need to send the userIp? https://github.com/EverlyWell/www/pull/1100
  // const userIp = await getUserIp();

  const response = await api.post<LineItem>(
    `/v1/orders/${data.orderId}/line_items`,
    {
      event_id: eventId,
      ...data.lineItem,
    },
  );

  try {
    /* successful add to cart tracking */
    trackJustUno('cartItemAdd', {
      productid: response.data.product_id,
      variationid: response.data.variant_id,
      quantity: data.lineItem.quantity,
      price: response.data.amount,
    });

    window?.dataLayer.push({
      event: 'addToCart',
      eventId: eventId,
      ecommerce: {
        currencyCode: 'USD',
        add: {
          products: [
            {
              id: response.data.variant_id,
              name: response.data.product_name,
              price: response.data.total,
              is_subscription: 'false',
              brand: '',
              category: '',
              variant: '',
              quantity: data.lineItem.quantity,
            },
          ],
        },
      },
    });
  } catch (e) {}
  return response;
};

export const updateLineItemQuantity = async (data: {
  variantId: number;
  quantity: number;
  orderId: number;
}) =>
  api.post<LineItem>(`/v1/orders/${data.orderId}/line_items`, {
    variant_id: data.variantId,
    quantity: data.quantity,
    total_quantity: data.quantity,
  });

export const removeLineItem = async (data: {
  orderId: number;
  lineItemId: number;
}) => api.delete(`/v1/orders/${data.orderId}/line_items/${data.lineItemId}`);

export const applyPromoCode = async (data: { code: string; orderId: number }) =>
  api.put<Order>(`/v2/orders/${data.orderId}/add_promo`, {
    coupon_code: data.code,
  });

export const removeAllPromos = async (data: { orderId: number }) =>
  api.put<Order>(`/v2/orders/${data.orderId}/remove_promos`);
